<script lang="ts" setup>
import type { AcceptedFilter } from '../../../Models'

const emits = defineEmits<{
  'filter:start': []
  'filter:remove': [fitler: AcceptedFilter]
}>()

const props = defineProps<{
  accepted?: AcceptedFilter[]
  hideFilters?: boolean
  hiddenAccepted?: string[]
}>()

const query = defineModel<string>('query')
</script>

<template>
  <div class="flex flex-col gap-2">
    <div class="flex flex-wrap items-center gap-2">
      <slot name="prefix" />
      <UInput
        v-model="query"
        type="search"
        class="max-w-sm"
        icon="i-lucide-search"
        placeholder="Я ищу"
      />
      <UButton
        v-if="!props.hideFilters"
        color="neutral"
        variant="ghost"
        icon="i-lucide-settings-2"
        label="Фильтр"
        @click="emits('filter:start')"
      >
        <template v-if="props.accepted?.length" #trailing>
          <UBadge :label="props.accepted.length" class="rounded-full" />
        </template>
      </UButton>
      <slot name="suffix" />
    </div>
    <div v-show="props.accepted?.length" class="flex flex-wrap items-center gap-2">
      <UBadge v-for="filter in props.accepted" :key="filter.key" :label="filter.label" class="rounded-full">
        <template #trailing>
          <UIcon name="i-lucide-x" class="cursor-pointer" @click="emits('filter:remove', filter)" />
        </template>
      </UBadge>
    </div>
  </div>
</template>
